import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { bl_fi_mst_item_line_RowClass, FinancialItemContainerModel, PricingSchemeLinkContainerModel } from 'blg-akaun-ts-lib';
import { UomPricingSchemeModel } from '../../models/uom-pricing-scheme.model';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
// import 'rxjs/add/operator/take';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

interface PricingScheme {
  uom_guid: string;
  label_guid: string;
  price_name: string;
  price_amount: number;
}

@Component({
  selector: 'app-pricing-scheme-uom',
  templateUrl: './pricing-scheme-uom.component.html',
  styleUrls: ['./pricing-scheme-uom.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PricingSchemeUOMComponent implements OnInit, OnDestroy {

  @Input() isInclusiveTax: boolean;
  @Input() uomGuid: FormControl;
  @Input() pricingScheme: FormControl;
  @Input() fiitem$: Observable<FinancialItemContainerModel>;
  @Input() pricing$: Observable<PricingSchemeLinkContainerModel>[];
  @Input() unitPriceType: string;
  @Input() defaultPricingHdr: string;
  @Input() canEdit: boolean;
  @Output() uomChange = new EventEmitter<FormControl>();
  @Output() pricingSchemeChange = new EventEmitter<FormControl>();
  @Output() uomToBaseRatio = new EventEmitter<any>();
  @Output() unitPrice = new EventEmitter<number>();
  private subs = new SubSink();

  uomfilterControl = new FormControl();
  pricingSchemefilterControl = new FormControl();
  filteredUOM$: ReplaySubject<bl_fi_mst_item_line_RowClass[]> = new ReplaySubject<bl_fi_mst_item_line_RowClass[]>(1);
  filteredPricingScheme$: ReplaySubject<PricingScheme[]> = new ReplaySubject<PricingScheme[]>(1);
  uomList: bl_fi_mst_item_line_RowClass[];
  pricingSchemeList: any[] = [];
  pricing: any[] = [];
  selectedUOM;
  selectedPrice;
  uomName;
  pricingSchemeName;
  constructor(private cd: ChangeDetectorRef) {

  }

  ngOnInit() {
    if(this.canEdit===false){
      this.canEdit = false;
    }else{
      this.canEdit = true;
    }

    if (this.pricingScheme.value) {
      this.selectedPrice = this.pricingScheme.value;
    }

    this.subs.sink =
      combineLatest([this.fiitem$, this.pricing$]).pipe(
      ).subscribe(
        {
          next: (([item, pricing]: any) => {
            if(item && pricing){
            this.pricing = pricing;
            const baseUOM = <bl_fi_mst_item_line_RowClass>{
              ...item.bl_fi_mst_item_hdr,
              uom: item.bl_fi_mst_item_hdr.uom,
              quantity: 1
            };
            this.uomList = [baseUOM, ...item.bl_fi_mst_item_lines.filter(l => l.uom)];

            this.selectedUOM = this.uomList[0]?.guid;
            if(!this.canEdit){
              this.uomName = this.uomList[0]?.uom;
            }
            this.filteredUOM$.next(this.uomList);

            if (this.selectedUOM == this.uomList[0].guid) {
              this.pricingSchemeList = [];
              if (this.pricing && this.pricing.length > 0) {
                this.pricing.forEach((p: any) => {
                  let uomPricingSchemeModel = new UomPricingSchemeModel;
                  uomPricingSchemeModel.price_name = p.pricing_hdr;
                  uomPricingSchemeModel.price_amount_incl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price) :
                    this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price) : null;
                  uomPricingSchemeModel.price_amount_excl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price_excl_tax) :
                    this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price_excl_tax) : null;
                  uomPricingSchemeModel.uom = p.bl_fi_mst_pricing_scheme_link.uom;
                  uomPricingSchemeModel.guid = p.bl_fi_mst_pricing_scheme_link.item_hdr_guid;
                  uomPricingSchemeModel.guid_pricing_scheme_hdr = p.bl_fi_mst_pricing_scheme_link.guid_pricing_scheme_hdr;
                  uomPricingSchemeModel.isBaseUom = true;
                  this.pricingSchemeList.push(uomPricingSchemeModel);

                })

              }

            }
            else {

              this.pricingSchemeList = [];
              if (this.pricing && this.pricing.length > 0) {
                this.pricing.forEach((p: any) => {
                  let uomPricingSchemeModel = new UomPricingSchemeModel;
                  uomPricingSchemeModel.price_name = p.pricing_hdr;
                  uomPricingSchemeModel.price_amount_incl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price) :
                    this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price) : null;
                  uomPricingSchemeModel.price_amount_excl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price_excl_tax) :
                    this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price_excl_tax) : null;
                  uomPricingSchemeModel.uom = p.bl_fi_mst_pricing_scheme_link.uom;
                  uomPricingSchemeModel.guid = p.bl_fi_mst_pricing_scheme_link.item_line_guid;
                  uomPricingSchemeModel.guid_pricing_scheme_hdr = p.bl_fi_mst_pricing_scheme_link.guid_pricing_scheme_hdr;
                  uomPricingSchemeModel.isBaseUom = false;
                  this.pricingSchemeList.push(uomPricingSchemeModel);
                })

              }



            }




            if (this.uomGuid.value) {
              this.onUOMSelected(this.uomGuid.value);

              if (this.selectedPrice) {
                this.pricingScheme.patchValue(this.selectedPrice);
              }



              if (this.defaultPricingHdr) {
                const defaultPrice = this.pricingSchemeList.filter(l => l.guid_pricing_scheme_hdr === this.defaultPricingHdr);
                if (defaultPrice.length > 0) {
                  this.onPriceSelected(defaultPrice[0]);
                  this.pricingScheme.patchValue(defaultPrice[0]);
                }
                
              }
              if(!this.canEdit){
                if(this.pricingScheme.value){
                  this.pricingSchemeName =  this.pricingScheme.value.price_amount_incl_tax +" ("+this.pricingScheme.value.price_name+")";
                }else{
                  this.pricingSchemeName = "";
                }
              }
            }
          }
          })
        });

    this.subs.sink = this.pricingSchemefilterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({ next: resolve => this.filterPricingScheme(resolve) });
    this.subs.sink = this.uomfilterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({ next: resolve => this.filterUOM(resolve) });

  }


  filterPricingScheme(search: string) {
    let pricingScheme = this.pricingSchemeList;


    if (this.selectedUOM) {
      pricingScheme = this.pricingSchemeList.filter(l => l.guid === this.selectedUOM);
      this.filteredPricingScheme$.next(pricingScheme);
    }

    if (!search) {
      this.filteredPricingScheme$.next(pricingScheme);
    } else {
      search = search.toLowerCase();
      const filter = pricingScheme.filter(price =>
        `${price.price_name}: ${price.price_name.toString()}`.toLowerCase().includes(search));
      this.filteredPricingScheme$.next(filter);
    }
  }

  filterUOM(search: string) {
    if (!search) {
      this.filteredUOM$.next(this.uomList);
    } else {
      search = search.toLowerCase();
      const filter = this.uomList.filter(l =>
        l.uom.toLowerCase().includes(search));
      this.filteredUOM$.next(filter);
    }
  }

  onUOMSelected(e) {
    this.selectedUOM = e;

    if (this.selectedUOM == this.uomList[0].guid) {
      this.pricingSchemeList = [];
      if (this.pricing && this.pricing.length > 0) {
        this.pricing.forEach((p: any) => {
          let uomPricingSchemeModel = new UomPricingSchemeModel;
          uomPricingSchemeModel.price_name = p.pricing_hdr;
          uomPricingSchemeModel.price_amount_incl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price) :
            this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price) : null;
          uomPricingSchemeModel.price_amount_excl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price_excl_tax) :
            this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price_excl_tax) : null;
          uomPricingSchemeModel.uom = p.bl_fi_mst_pricing_scheme_link.uom;
          uomPricingSchemeModel.guid = p.bl_fi_mst_pricing_scheme_link.item_hdr_guid;
          uomPricingSchemeModel.guid_pricing_scheme_hdr = p.bl_fi_mst_pricing_scheme_link.guid_pricing_scheme_hdr;
          uomPricingSchemeModel.isBaseUom = true;
          this.pricingSchemeList.push(uomPricingSchemeModel);
        })

      }

    }
    else {

      this.pricingSchemeList = [];
      if (this.pricing && this.pricing.length > 0) {
        this.pricing.forEach((p: any) => {
          let uomPricingSchemeModel = new UomPricingSchemeModel;
          uomPricingSchemeModel.price_name = p.pricing_hdr;
          uomPricingSchemeModel.price_amount_incl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price) :
            this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price) : null;
          uomPricingSchemeModel.price_amount_excl_tax = this.unitPriceType.toUpperCase() === "PURCHASE" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.purchase_unit_price_excl_tax) :
            this.unitPriceType.toUpperCase() === "SALES" ? this.setTwoNumberDecimal(p.bl_fi_mst_pricing_scheme_link?.sales_unit_price_excl_tax) : null;
          uomPricingSchemeModel.uom = p.bl_fi_mst_pricing_scheme_link.uom;
          uomPricingSchemeModel.guid = p.bl_fi_mst_pricing_scheme_link.item_line_guid;
          uomPricingSchemeModel.guid_pricing_scheme_hdr = p.bl_fi_mst_pricing_scheme_link.guid_pricing_scheme_hdr;
          uomPricingSchemeModel.isBaseUom = false;
          this.pricingSchemeList.push(uomPricingSchemeModel);
        })

      }



    }


    if (this.pricing && this.pricing.length > 0) {
      const pricingScheme = this.pricingSchemeList.filter(l => l.guid == e);
      if (pricingScheme.every(p => p)) {
        this.filteredPricingScheme$.next(pricingScheme);
        this.pricingScheme.reset();

        if (!this.pricingScheme.disabled) {
          this.pricingScheme.enable();
        }
      }
    }

    const uom = this.uomList.find(l => l.guid.toString() === e);

    this.uomToBaseRatio.emit(uom);


  }

  onPriceSelected(e: any) {
    this.unitPrice.emit(e);

  }

  setTwoNumberDecimal(num) {
    if (num == null) {
      return 0.00;
    }
    return parseFloat(num).toFixed(2);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
